"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextPositionCarousel = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _react = require("react");
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _models = require("../../models");
var _components = require("./components");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TextPositionCarousel = () => {
  const {
    textPosition,
    setTextPosition
  } = (0, _contexts.useQrCodeDialog)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const positionOptions = (0, _react.useMemo)(() => [{
    value: _models.QRTextPosition.Blank,
    label: translations.qrCodeOptionWithoutScanMeLabel,
    image: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.NoFrameImage, {})
  }, {
    value: _models.QRTextPosition.Bottom,
    label: translations.qrCodeOptionWithScanMeLabelOnBottom,
    image: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.BottomFrameImage, {})
  }, {
    value: _models.QRTextPosition.Top,
    label: translations.qrCodeOptionWithScanMeLabelOnTop,
    image: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.TopFrameImage, {})
  }], [translations]);
  const onPositionClick = (0, _react.useCallback)(position => {
    setTextPosition(position.value);
  }, [setTextPosition]);
  const slider = (0, _react.useMemo)(() => ({
    drag: false,
    slides: {
      perView: positionOptions.length,
      spacing: _constants.SPACING
    }
  }), [positionOptions.length]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    numberOfSlides: positionOptions.length,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Carousel, {
      pagination: _constants.pagination,
      navigation: _constants.navigation,
      slider: slider,
      children: positionOptions.map(position => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
        minWidth: _constants.SLIDE_WIDTH,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.TextPosition, {
          value: position,
          isActive: textPosition === position.value,
          onClick: onPositionClick
        })
      }, position.value))
    })
  });
};
exports.TextPositionCarousel = TextPositionCarousel;
